export default {
  preservedSelected: null,
};
